
import {Component, Mixins, Prop} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import RaporKosulPicker from "@/components/pickers/RaporKosulPicker.vue";
import {RaporKosulEntity} from "@/entity/RaporKosulEntity";
import {RaporAlanEntity} from "@/entity/RaporAlanEntity";
import VergiNumarasi from "@/components/inputs/VergiNumarasi.vue";
import IcraDairesiPicker from "@/components/pickers/IcraDairesiPicker.vue";
import TelefonNumarasi from "@/components/inputs/TelefonNumarasi.vue";
import DosyaEsasNumarasi from "@/components/inputs/DosyaEsasNumarasi.vue";
import Dates from "@/components/inputs/Dates.vue";
import TebligatDurumuPicker from "@/components/pickers/TebligatDurumuPicker.vue";
import TakipTipiPicker from "@/components/pickers/TakipTipiPicker.vue";
import TakipAltTipiPicker from "@/components/pickers/TakipAltTipiPicker.vue";
import TakipYoluPicker from "@/components/pickers/TakipYoluPicker.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import MasrafCesidiPicker from "@/components/pickers/MasrafCesidiPicker.vue";
import TakipDurumuPicker from "@/components/pickers/TakipDurumuPicker.vue";
import TahsilatTuruPicker from "@/components/pickers/TahsilatTuruPicker.vue";

@Component({
  components: {
    RaporKosulPicker,
    VergiNumarasi,
    IcraDairesiPicker,
    TelefonNumarasi,
    DosyaEsasNumarasi,
    Dates,
    TebligatDurumuPicker,
    TakipTipiPicker,
    TakipAltTipiPicker,
    TakipYoluPicker,
    Tutar,
    MasrafCesidiPicker,
    TakipDurumuPicker,
    TahsilatTuruPicker
  }
})
export default class RaporQueryBuilderSimple extends Mixins(ObjectInputMixin) {
  @Prop({}) raporAlanlari!: Array<RaporAlanEntity>;
  localValue: RaporKosulEntity = new RaporKosulEntity();

  // Koşul verilemeyen alanlar (izinli operatörü olmayanlar) listede görünmez;
  // kullanıcı boş sonuç üreten koşul kuramaz.
  get kosulVerilebilirAlanlar(): Array<RaporAlanEntity> {
    return (this.raporAlanlari || []).filter((a: any) => (a.kosul_operatorleri || []).length > 0);
  }

  /**
   * Alan değişince operatör ve değer sıfırlanır: izinli operatör kümesi alana
   * göre değişiyor; eski operatör yeni alanda geçersiz kalırsa koşul backend'de
   * sessizce atlanıyordu.
   */
  alanDegisti() {
    this.$set(this.localValue, "kosul_operator_id", null);
    this.$set(this.localValue, "deger", null);
    this.input();
  }

  // Tek izinli operatörü olan alanda (örn. Takip Durumu yalnız "eşittir")
  // operatörü otomatik seç; kullanıcı seçmeyi unutunca koşul sessizce
  // atlanıyordu (backend operatörsüz koşulu yok sayar).
  operatorleriAl(operatorler: any[]) {
    if (operatorler && operatorler.length === 1 && !this.localValue.kosul_operator_id) {
      this.$set(this.localValue, "kosul_operator_id", operatorler[0].id);
      this.input();
    }
  }

  get kosulInput() {
    if (this.raporAlanlari && this.localValue.rapor_alan_id) {
      return this.raporAlanlari.find(v => v.id == this.localValue.rapor_alan_id)?.kosul_input ?? 'v-text-field';
    } else
      return 'v-text-field';
  }
}
